/* eslint-disable no-console */

const resetMobileNav = () => {
  if (document.querySelector('.mobile-nav .plus-minus')) {
    [].map.call(document.querySelectorAll('.mobile-nav .plus-minus'), (item) => {
      item.classList.remove('minus');
    });
  }
  if (document.querySelector('.show-items')) {
    [].map.call(document.querySelectorAll('.show-items'), (item) => {
      item.classList.remove('show-items');
      const subnav = item.querySelector('.mobile-subnav');
      subnav.classList.add('hidden');
    });
  }
};

const init = () => {
  if (document.querySelector('.mobile-nav .plus-minus')) {
    [].map.call(document.querySelectorAll('.mobile-nav .plus-minus'), elem => elem.addEventListener('click', (event) => {
      event.preventDefault();
      if (event.currentTarget.parentElement.nextElementSibling && !event.currentTarget.parentElement.nextElementSibling.classList.contains('hidden') && event.currentTarget.classList.contains('minus')) {
        event.currentTarget.parentElement.nextElementSibling.classList.add('hidden');
        event.currentTarget.classList.remove('minus');
        event.currentTarget.parentElement.parentElement.classList.remove('show-items');
      } else {
        [].map.call(document.querySelectorAll('.mobile-nav .plus-minus'), (item) => {
          if (!item.parentElement.nextElementSibling.classList.contains('hidden')) {
            item.parentElement.nextElementSibling.classList.add('hidden');
            item.parentElement.parentElement.classList.remove('show-items');
          }
          if (item.classList.contains('minus')) {
            item.classList.remove('minus');
          }
        });
        event.currentTarget.parentElement.parentElement.classList.add('show-items');
        event.currentTarget.parentElement.nextElementSibling.classList.remove('hidden');
        event.currentTarget.classList.add('minus');
      }
    }));
  }
};

export {
  init,
  resetMobileNav,
};
/* eslint-enable no-console */
